import { JSX, useState, useEffect } from 'react'


import { HttpBody } from '@/lib/request'

import * as detective from '@/lib/detective.js'

import * as company_model from '@/model/company.js'

import * as company_storage from '@/storage/company.js'

import * as toast from '@/components/ui/toast.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Drawer from '@/components/ui/drawer.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Field from '@/components/ui/field.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Fieldset from '@/components/ui/fieldset.tsx'




export async function update
(...[_id, params]: Parameters<typeof company_storage.update>): Promise<void>
{
	try
	{
		await company_storage.update(_id, params)

	}

	catch (e)
	{
		toast.error(e as Error)

	}

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function View
(
	props: {
		_id: string

	},

)
:	JSX.Element
{
	type TRawDocType = HttpBody< Required<company_model.TRawDocType> >

	let [doc, update_doc] = useState<null | TRawDocType>(null)

	let on_update = (name: string, value: unknown): void =>
	{
		let params = { [name]: value }

		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		update(props._id, params)

		update_doc({ ...doc, ...params } as TRawDocType)

	}


	useEffect(
		() =>
		{
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			company_storage.retrieve(props._id).then(update_doc)

		},

		[],

	)

	if (detective.is_empty(doc) )
	{
		return <></>

	}

	return (
		<Fieldset.Root name="项目资料">
			<Field.Text
				label="项目名称"
				helper="请填写项目名称"
				name="name"
				value={doc.name}
				change={on_update}
			/>

			<Field.Text
				label="所属区域"
				name="league"
				value={doc.league}
				change={on_update}
			/>


		</Fieldset.Root>

	)

}


export default function (_id: string): void
{
	Drawer.open(
		<View _id={_id} />,

		{ size: 'lg', title: '查看项目' },

	)


}
